import { render, staticRenderFns } from "./media.producer.vue?vue&type=template&id=61e96e84&scoped=true&"
import script from "./media.producer.vue?vue&type=script&lang=js&"
export * from "./media.producer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e96e84",
  null
  
)

export default component.exports